<script>
  import CodeMirrorComponent from 'svelte-codemirror-component';
  import { createEventDispatcher, onMount, tick } from 'svelte';
  const dispatch = createEventDispatcher();
  export let saveDisabled = false;
  export let lang = 'json';
  export let text = '';

  let Editor, Value;
  let showing = false;
  const reload = async () => {
    showing = false;
    await tick();
    showing = true;
  };
  const saveConfig = () => {
    dispatch('save', Value);
    reload();
  };
  const change = (e) => {
    dispatch('update', Value);
  };

  $: if (text) {
    Value = text;
  }
  onMount(() => {
    reload();
  });
</script>

{#if showing}
  <p>{lang} editor</p>
  {#if window}
    <CodeMirrorComponent on:change={change} bind:Editor bind:Value Mode={lang} Options={{ theme: 'dracula' }} />
  {/if}
  <br />
  {#if !saveDisabled}
    <button class="primary" on:click={() => saveConfig()}>Save</button>
  {/if}
{/if}
